import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import NavProfile from '../../components/user/NavProfile';
import "./User.css";
import banner from '../../static/images/profile-banner.png';

export default function ProfileUser() {
    const {avatar} = useOutletContext(); // otteniamo avatar dal contesto
    const [userName, setUserName] = useState("Utente");
    const [address, setAddress] = useState("Non presente");
    const [city, setCity] = useState("Città");
    const [phone, setPhone] = useState("Telefono");
    const [email, setEmail] = useState("Telefono");
    const [role, setRole] = useState("Ruolo");
    const [register, setRegister] = useState("Data");

    useEffect(() => {
        // Recupera il nome utente dal localStorage
        setUserName(localStorage.getItem("name"));
        setAddress(localStorage.getItem("address"));
        setCity(localStorage.getItem("comune"));
        setPhone(localStorage.getItem("phone"));
        setEmail(localStorage.getItem("username"));
        const localeRole = localStorage.getItem("role");
        setRole(localeRole.substring(5));
        const date = new Date(localStorage.getItem("createdAt"));
        setRegister(format(date, 'd MMMM yyyy', { locale: it }));
    }, []);

  	return (
  	<>
  	    {/* Header */}
  	    <div className="row">
  	        <div className="col-md-12">
  	            <div className="card mb-6">
                    <div className="user-profile-header-banner">
                        <img src={banner} alt="Banner image profile" className="rounded-top" />
                    </div>
                    <div className="user-profile-header d-flex flex-column flex-lg-row text-sm-start text-center mb-8">
                        <div className="flex-shrink-0 mt-1 mx-sm-0 mx-auto">
                            <img src={avatar} alt="image profile" className="d-block h-auto ms-0 ms-sm-6 rounded-3 user-profile-img" />
                        </div>
                        <div className="flex-grow-1 mt-3 mt-lg-5">
                            <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-5 flex-md-row flex-column gap-4">
                                <div className="user-profile-info">
                                    <h4 className="mb-2 mt-lg-7">{userName}</h4>
                                     <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-4 mt-4">
                                        <li className="list-inline-item">
                                            <i className="bx bx-palette me-2 align-top"></i>
                                            <span className="fw-medium">{role}</span>
                                        </li>
                                        <li className="list-inline-item">
                                            <i className="bx bx-map me-2 align-top"></i>
                                            <span className="fw-medium">{city}</span>
                                        </li>
                                        <li className="list-inline-item">
                                            <i className="bx bx-calendar me-2 align-top"></i>
                                            <span className="fw-medium"> Registrato il {register}</span>
                                        </li>
                                     </ul>
                                </div>
                            </div>
                        </div>
                    </div>
  	            </div>
  	        </div>
        </div>
        {/* /Header */}
        {/* Navbar */}
        <NavProfile />
        {/* /Navbar */}
        {/* Profile */}
        <div className="row">
            <div className="col-xl-4 col-lg-5 col-md-5">
                {/* About Profile */}
                <div className="card mb-6">
                    <div className="card-header align-items-center">
                        <h5 className="card-action-title mb-0">
                            <i className="bx bx-info-circle bx-lg text-body me-4"></i>
                            Informazioni
                        </h5>
                    </div>
                    <div className="card-body pt-3">
                        <ul className="list-unstyled mb-0">
                            <li className="d-flex align-items-center mb-4">
                                <i className="bx bx-user"></i>
                                <span className="fw-medium mx-2">Nome Completo:</span>
                                <span>{userName}</span>
                            </li>
                            <li className="d-flex align-items-center mb-4">
                                <i className="bx bx-map"></i>
                                <span className="fw-medium mx-2">Indirizzo:</span>
                                <span>{address}</span>
                            </li>
                            <li className="d-flex align-items-center mb-4">
                                <i className="bx bxs-city"></i>
                                <span className="fw-medium mx-2">Città:</span>
                                <span>{city}</span>
                            </li>
                            <li className="d-flex align-items-center mb-4">
                                <i className="bx bx-phone"></i>
                                <span className="fw-medium mx-2">Telefono:</span>
                                <span>{phone}</span>
                            </li>
                            <li className="d-flex align-items-center mb-4">
                                <i className="bx bx-envelope"></i>
                                <span className="fw-medium mx-2">Email:</span>
                                <span>{email}</span>
                            </li>
                            <li className="d-flex align-items-center mb-4">
                                <i className="bx bx-crown"></i>
                                <span className="fw-medium mx-2">Ruolo:</span>
                                <span>{role}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        {/* /Profile */}

    </>
	);
}